export default (props, { rhythm, scale }) => ({
  legal: {
    textTransform: 'none',
    fontSize: scale(-0.5)
  }
})
